<template>
  <v-layout row ma-0 mt-2 v-if="newUser">
    <v-layout column>
      <span class="title">Cadastrar novo usuário</span>
      <v-layout>
        <v-flex xs12 md4>
          <v-text-field
            label="Nome do usuário"
            class="mr-2"
            v-model="newUserModel.userName"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field
            label="Email"
            class="mr-2"
            v-model="newUserModel.email"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field
            label="Senha Provisória"
            class="mr-2"
            type="password"
            v-model="newUserModel.password"
            required
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md4>
          <v-text-field
            class="mr-2"
            label="CPF"
            v-model="newUserModel.cpf"
            required
            v-mask="'###.###.###-##'"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-text-field
            class="mr-2"
            label="CNH"
            v-model="newUserModel.cnh"
            required
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout class="ma-0" justify-end>
        <v-btn class="pr-3" @click="cleanFields" color="error">
          <span class="white--text">Cancelar</span>
        </v-btn>
        <v-btn color="success" @click="registerNewUser">
          <span class="white--text">Cadastrar</span>
        </v-btn>
      </v-layout>
    </v-layout>
  </v-layout>
</template>
<script>
import UserController from '../../controllers/UserController';
export default {
  data() {
    return {
      userController: new UserController(this.$resource),
      newUserModel: {},
    };
  },
  props: {
    newUser: {
      required: true,
      type: Boolean,
    },
    clientModelId: {
      required: false,
      type: Number,
    },
  },
  methods: {
    cleanFields() {
      this.newUserModel = {};
      this.$emit('cancel');
    },
    async registerNewUser() {
      try {
        this.blockScreen = true;

        //manter a interface de cadastro de cliente já existente no back-end
        const user = await this.userController.createByAdm({
          cpf: this.newUserModel.cpf,
          drive_livence: this.newUserModel.cnh,
          email: this.newUserModel.email,
          hasForPasswordChange: true,
          name: this.newUserModel.userName,
          password: this.newUserModel.password,
          clientsUser: [{ value: this.clientModelId }],
          profile_id: 2,
          approved: true,
        });

        if (user.ok) {
          this.cleanFields();
          return this.$awn.success('Usuário cadastrado com sucesso.');
        } else {
          return this.$awn.alert(`Erro ao cadastrar usuário. ${user.message}`);
        }
      } catch (error) {
        return this.$awn.alert(error.message);
      } finally {
        this.blockScreen = false;
      }
    },
  },
};
</script>
